export default __webpack_public_path__ + "static/media/PictCamp.e25f4120.jpg";